import type { PageTour } from './types';

/**
 * Every page that has a guided tour. The Topbar's tour button appears on a
 * page only when it is listed here.
 *
 * To add one: write `tours/<page>.ts` (steps, demo routes, write guard), add
 * `data-tour` anchors to the page, put the step copy under `tour.<page>` in
 * both locale files, and add an entry below.
 *
 * Demo records live in `src/demo/`, one file per API domain, shared by every
 * tour: reuse the cast in `demo/people.ts` and add a responder to the domain
 * file rather than writing demo data inside a tour.
 */
export const PAGE_TOURS: PageTour[] = [
  {
    id: 'patients',
    path: '/dashboard/patients',
    load: () => import('./tours/patients').then((m) => m.patientsTour),
  },
  {
    id: 'patient-profile',
    // `/dashboard/patients/:patientId`, but not the import pages beside it.
    path: /^\/dashboard\/patients\/(?!import$)[^/]+$/,
    load: () =>
      import('./tours/patient-profile').then((m) => m.patientProfileTour),
  },
];

export function findPageTour(pathname: string): PageTour | undefined {
  const path = pathname.replace(/\/+$/, '');
  return PAGE_TOURS.find((tour) =>
    typeof tour.path === 'string' ? tour.path === path : tour.path.test(path),
  );
}
